import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/i18n";

const currency = (n) =>
  new Intl.NumberFormat("de-CH", { style: "currency", currency: "CHF" }).format(n || 0);

export default function FinancePage() {
  const { lang } = useLang();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/finance/overview").then((r) => setD(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="finance-page">
      <div>
        <h1 className="font-display font-light text-3xl tracking-tight">
          {t(lang, "finance_title")}
        </h1>
        <p className="mt-1 text-white/50 text-sm">{t(lang, "finance_subtitle")}</p>
      </div>

      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        <FinanceCard testid="fin-revenue" label={t(lang, "finance_revenue")} value={currency(d?.revenue)} />
        <FinanceCard testid="fin-costs" label={t(lang, "finance_costs")} value={currency(d?.costs)} />
        <FinanceCard testid="fin-gross" label={t(lang, "finance_gross")} value={currency(d?.gross_profit)} />
        <FinanceCard testid="fin-tax" label={t(lang, "finance_tax_reserve")} value={currency(d?.tax_reserve)} tone="warning" />
        <FinanceCard testid="fin-distributable" label={t(lang, "finance_distributable")} value={currency(d?.distributable_profit)} tone="cyan" />
        <FinanceCard testid="fin-target" label={t(lang, "finance_target")} value={currency(d?.target_daily_profit)} />
      </div>

      {d?.notes && (
        <div className="hq-card p-6">
          <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">
            Notes
          </div>
          <ul className="space-y-2 text-sm text-white/70">
            {d.notes.map((n, i) => (
              <li key={i} className="flex gap-2">
                <span className="text-[color:var(--hq-cyan)] mt-1">•</span>
                <span>{n}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

function FinanceCard({ label, value, tone = "default", testid }) {
  const cls =
    tone === "cyan"
      ? "text-[color:var(--hq-cyan)]"
      : tone === "warning"
      ? "text-[color:var(--hq-warning)]"
      : "text-white";
  return (
    <div className="hq-card p-5" data-testid={testid}>
      <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">
        {label}
      </div>
      <div className={`font-mono text-2xl ${cls}`}>{value}</div>
    </div>
  );
}
